import take from 'lodash/take'
import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { BlogStatus } from '../BlogStatus'
import { defaultCover } from '@ztechapps/blog.common'
import { Link } from 'react-router-dom'
import { HorizontalStack, Icon, ShowIf } from '@ztechapps/webui.util'
import { Tags } from '@ztechapps/webui.input'
import { formatDateTime, truncate } from '@ztechapps/common.utils'
import type { DateType } from '@ztechapps/common.utils'

export type BlogBoxProps = {
  title: string
  summary: string
  updatedAt: DateType
  status?: string
  tags?: string[]
  cover?: string
  linkToPath: string
}
export const BlogBox = ({ title, summary, updatedAt, status, tags, cover, linkToPath }: BlogBoxProps) => {
  cover = !isEmpty(cover) ? cover : defaultCover

  return (
    <Link to={linkToPath}>
      <div
        className=""
        style={{
          height: '250px',
          backgroundImage: `url('${cover}')`,
          width: '100%',
          backgroundSize: 'cover',
        }}
      >
        <div
          className="d-flex flex-column justify-content-end   "
          style={{
            height: '100%',
            background: 'linear-gradient(to bottom, rgba(6, 27, 65, 0) 0%, #010a01 100%)',
            borderRadius: '10px',
          }}
        >
          <div className="p-2 text-white  ">
            <div>
              <h2>
                <ShowIf condition={!!status}>
                  <BlogStatus value={status} />
                </ShowIf>
                {truncate(title, 50)}
              </h2>
            </div>

            <HorizontalStack gap={2} className="small mb-1 ">
              <Icon name="clock" />
              <span>{formatDateTime(updatedAt)}</span>
            </HorizontalStack>
            <p>{truncate(summary, 150)}</p>
            <ShowIf condition={!!tags}>
              <div className="">
                <Tags dataArray={take(tags, 5)} />
              </div>
            </ShowIf>
          </div>
        </div>
      </div>
    </Link>
  )
}
